import React from "react";
import "./FinalCTA.scss";

const FinalCTA = () => {
  return (
    <section className="final-cta" id="contacto">
      <div className="container">
        <div className="final-cta__box">
          <div className="final-cta__content">
            <div className="final-cta__eyebrow">Contacto</div>

            <h2 className="final-cta__title">
              Encuentra la maquinaria ideal para impulsar tu operación.
            </h2>

            <p className="final-cta__description">
              Contáctanos y recibe información sobre el equipo que necesitas.
              En Makinaria Dima estamos listos para ayudarte a encontrar una
              solución confiable para tu empresa o taller.
            </p>

            <div className="final-cta__actions">
              <a
                href={`https://wa.me/525515898591?text=${encodeURIComponent(
                  "Hola, vi su página y me interesa su maquinaria. ¿Me podrían dar más información?"
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="final-cta__btn final-cta__btn--primary"
              >
                Cotizar ahora
              </a>
            </div>
          </div>

          <div className="final-cta__info">
            <div className="final-cta__card">
              <span className="final-cta__label">Teléfono</span>
              <h3>55 1589 8591</h3>
              <p>Atención directa para resolver dudas sobre maquinaria y disponibilidad.</p>
            </div>

            <div className="final-cta__card">
              <span className="final-cta__label">Ubicación</span>
              <h3>Santiago Tulantepec, Hidalgo</h3>
              <p>C. Ingenieros Industriales 272, Col. Ex Hacienda de San Francisco Huatengo.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;